import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";
import { InputPembayaranBody, InputPembayaranResponse } from "../../constants/types";

type InputPembayaranParams = {
    body: InputPembayaranBody;
    params?: { grupProduk?: number };
};

const inputPembayaran = async ({ body, params }: InputPembayaranParams) => {
    const response = await axios.post<InputPembayaranResponse>(
        "/api/pembayaran",
        body,
        { params },
    );
    return response.data;
};

export default function useInputPembayaran() {
    const queryClient = useQueryClient();

    return useMutation(
        (args: InputPembayaranParams) => inputPembayaran(args),
        {
            onSuccess: () => {
                queryClient.invalidateQueries(["invoice"]);
                queryClient.invalidateQueries(["status-pembayaran"]);
            },
        },
    );
}
